import React, { FC, forwardRef } from "react";
import { TabProps, Tooltip } from "@mui/material";

import { StyledMuiTab } from "./styled";

interface IStyledTabWithTooltipProps extends TabProps {
  tooltip?: string;
}

export const StyledTab: FC<TabProps> = ({ ...props }) => <StyledMuiTab {...props} />;

export const StyledTabWithTooltip = forwardRef<HTMLDivElement, IStyledTabWithTooltipProps>(
  ({ tooltip, ...props }, ref) => {
    const tab = <StyledMuiTab ref={ref} {...props} />;

    if (!tooltip) {
      return tab;
    }

    return (
      <Tooltip title={tooltip} arrow>
        {tab}
      </Tooltip>
    );
  },
);

StyledTabWithTooltip.displayName = "StyledTabWithTooltip";
